import React, { useState, useEffect, useContext } from "react";
import useAxios from "../../services/useAxios.tsx";
import WithAuthentication from "context/Authentication/AuthenticationContext.ts";
const ProductContext = React.createContext({
  productList: [],
  hashtagList: [],
  tags: [],
  selectHashtags: [],
  setSelectHashtags: () => {},
  setProductUpdater: () => {},
  searchInput: "",
  setSearchInput: () => {},
  searchProduct: () => {},
  loading: false,
  setLoading: () => {},
});
export default ProductContext;

export function ProductContextProvider({ children }) {
  const { execute: getProductApi } = useAxios("api3/getproduct");
  const { execute: findHashtagsApi } = useAxios("api3/Find_hashtags");

  const [searchInput, setSearchInput] = useState("");

  const [productList, setProductList] = useState([]);
  const [hashtagList, setHashtagList] = useState([]);
  const [productListUpdater, setProductListUpdater] = useState(false);
  const [tags, setTags] = useState([]);
  const [productUpdater, setProductUpdater] = useState(false);
  const [selectHashtags, setSelectHashtags] = useState([]);
  const [productSearch, setProductSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const auth = useContext(WithAuthentication);
  const isAdmin = auth?.userInfo.userType == 0;

  useEffect(() => {
    let id = { hashtags: "" };
    let product = [];
    if (selectHashtags.length > 0) {
      id = { hashtags: `${selectHashtags.join(",")}` };
    }

    async function LoadPage() {
      setLoading(true);
      await getProductApi({
        // hashtags: 4
        hashtags: selectHashtags,
      }).then((data) => {
        let conditions = "";

        if (data?.products?.length == 0) {
          conditions = `is_in_menu/!=/-1`;
        } else {
          conditions = `is_in_menu/!=/-1@@id/!=/4`;
        }
        console.log(data);
        setProductList(data.products);
        setLoading(false);
        // setProductList()
        findHashtagsApi({
          conditions: conditions,
        }).then((data1) => {
          setHashtagList(data1);
          setTags(data1);
        });
      });

      // await getProductApi(id).then(data => {
      //   let temp = [...data?.products];
      //   // if (isAdmin == true) {
      //   //   temp = temp.filter(tem => tem.status == 1);
      //   // }
      //   if (!isAdmin) {
      //     temp = temp.filter(tem => tem.status == 0);
      //   }
      //   setProductList(temp.reverse());
      //   setProductSearch(temp);
      // });
    }
    LoadPage();
  }, [selectHashtags, productUpdater, isAdmin, productListUpdater]);

  const searchProduct = (searchInput) => {
    if (searchInput != "") {
      setProductList(
        productSearch.filter((v) => v.title.includes(searchInput) == true)
      );
    } else {
      setProductList(productSearch);
    }
  };

  return (
    <ProductContext.Provider
      value={{
        productList,
        hashtagList,
        tags,
        selectHashtags,
        setSelectHashtags,
        setProductUpdater,
        searchInput,
        setSearchInput,
        searchProduct,
        loading,
        setLoading,
        productListUpdater,
        setProductListUpdater,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}
